import { NavLink } from 'react-router-dom';
import EntitySelector from './EntitySelector.jsx';
import { useNavItems } from '../hooks/useNavItems.js';

function linkClass(isActive, admin) {
  const idle = admin
    ? 'text-slate-500 hover:bg-slate-100 hover:text-slate-700'
    : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900';
  return `flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
    isActive ? 'bg-slate-800 text-white' : idle
  }`;
}

export default function Sidebar() {
  const items = useNavItems();
  const main = items.filter((i) => !i.admin);
  const admin = items.filter((i) => i.admin);

  return (
    <aside
      className="hidden lg:flex flex-col w-64 shrink-0 bg-white border-r border-slate-200 sticky top-0 self-start h-screen overflow-y-auto"
      aria-label="Navigation latérale"
    >
      <EntitySelector />
      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
        {main.map(({ to, label, Icon, exact }) => (
          <NavLink key={to} to={to} end={exact} className={({ isActive }) => linkClass(isActive, false)}>
            <Icon size={16} aria-hidden />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-slate-100 px-3 py-3">
        {admin.map(({ to, label, Icon }) => (
          <NavLink key={to} to={to} className={({ isActive }) => linkClass(isActive, true)}>
            <Icon size={16} aria-hidden />
            {label}
          </NavLink>
        ))}
      </div>
    </aside>
  );
}
